import { useTranslation } from 'react-i18next';

import { Box, Modal } from '@mui/material';

import DeleteIcon from '../images/delete.svg?react';
import './Confirm.css';

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 'min(92vw, 420px)',
    bgcolor: '#FFFFFF',
    borderRadius: '32px',
    boxShadow: '0px 8px 32px rgba(0,0,0,0.2)',
    p: 0,
};

function Confirm(props: any) {
    const { records = [], handleConfirm, tKey, openConfirm, setOpenConfirm } = props;
    const { t } = useTranslation(undefined, { keyPrefix: tKey });

    const handleCancel = () => {
        setOpenConfirm(false);
    };

    const count = records.length || 0;
    const headline = t('confirmDelete');

    return (
        <Modal
            open={openConfirm}
            onClose={() => setOpenConfirm(false)}
            aria-labelledby='confirm-delete-title'
            aria-describedby='confirm-delete-description'
        >
            <Box sx={modalStyle}>
                <div className='confirm__wrapper'>
                    <div className='confirm__message'>
                        <span className='confirm__icon' role='img' aria-label='warning'>
                            ⚠️
                        </span>
                        <div className='confirm__text'>
                            <div className='confirm__line'>{t('description', { count })}</div>
                            <div className='confirm__line'>{headline}</div>
                        </div>
                    </div>
                    <div className='confirm__actions'>
                        <button type='button' className='confirm__btn confirm__btn--secondary' onClick={handleConfirm}>
                            <DeleteIcon className='confirm__delete-icon' />
                            {t('confirm')}
                        </button>
                        <button type='button' className='confirm__btn confirm__btn--primary' onClick={handleCancel}>
                            {t('cancel')}
                        </button>
                    </div>
                </div>
            </Box>
        </Modal>
    );
}

export default Confirm;
